/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {Box} from '@mui/material';
import Typography from '@mui/material/Typography';
import type {GridSlotsComponentsProps} from '@mui/x-data-grid-premium';
import {LoadingSpinner} from '../LoadingSpinner';

declare module '@mui/x-data-grid-premium' {
  interface FooterPropsOverrides {
    rowCount: number;
    expectedTotalRows?: number | null;
    isPartiallyLoading?: boolean;
  }
}

export const SuperTableFooter = (props: NonNullable<GridSlotsComponentsProps['footer']>) => {
  const {rowCount, expectedTotalRows, isPartiallyLoading} = props;
  const getRowCountDisplay = () => {
    // if still loading the first page, show the loading spinner
    if (rowCount === 0) {
      return <LoadingSpinner size={'sm'} style={{marginLeft: '1rem'}} />;
    }

    if (isPartiallyLoading && expectedTotalRows) {
      return (
        <>
          {`${Number(rowCount).toLocaleString()} of ~${expectedTotalRows.toLocaleString()} results `}
          <LoadingSpinner size={'sm'} style={{marginLeft: '1rem'}} />
        </>
      );
    }
    return `${Number(rowCount).toLocaleString()} results`;
  };
  return (
    <Box textAlign={'right'} p={2}>
      <Typography variant={'body2'}>{getRowCountDisplay()}</Typography>
    </Box>
  );
};
